import { UserLoginType } from "@/DTO";
import { getLocalItems } from "../../hooks";
import { userStoreType } from "./type";

let user: UserLoginType = {
  id: "",
  phone: "",
  first_name: "",
  last_name: "",
  status: "",
  created_at: "",
  accessToken: "",
  refreshToken: "",
  role: [],
  permission_list: []
};

if (
  getLocalItems("user") &&
  JSON.parse(getLocalItems("user")) != null &&
  JSON.parse(getLocalItems("user")) != ""
) {
  user = JSON.parse(getLocalItems("user"));
}

export const initialState: userStoreType = {
  value: { ...user },
  status: "idle"
};
